import type { OpportunityStatus } from '@fig/shared';

const OPPORTUNITY_STATUS_VALUES = [
  'new',
  'actioned',
  'dismissed',
  'withdrawn',
] as const satisfies readonly OpportunityStatus[];

export const DEFAULT_OPPORTUNITY_STATUS: OpportunityStatus = 'new';

export const OPPORTUNITY_STATUS_LABELS: Record<OpportunityStatus, string> = {
  new: 'New',
  actioned: 'Sent to Agent Platform',
  dismissed: 'Dismissed',
  withdrawn: 'Withdrawn',
};

export const OPPORTUNITY_STATUS_OPTIONS = OPPORTUNITY_STATUS_VALUES.map((status) => ({
  value: status,
  label: OPPORTUNITY_STATUS_LABELS[status],
}));

const OPPORTUNITY_STATUS_SET = new Set<string>(OPPORTUNITY_STATUS_VALUES);

export function isOpportunityStatus(status: string | null): status is OpportunityStatus {
  return !!status && OPPORTUNITY_STATUS_SET.has(status);
}

export function formatOpportunityStatus(status: string): string {
  return isOpportunityStatus(status) ? OPPORTUNITY_STATUS_LABELS[status] : status;
}

export function getOpportunityStatusVariant(status: string) {
  switch (status) {
    case 'new':
      return 'info' as const;
    case 'actioned':
      return 'success' as const;
    case 'dismissed':
      return 'outline' as const;
    case 'withdrawn':
      return 'secondary' as const;
    default:
      return 'secondary' as const;
  }
}
